import { Loader } from "@fluentui/react-northstar";
import React from "react";
import { Modal } from "@material-ui/core";
import classes from "./Loader.module.css"

const Element = (props) => (

    <Modal {...props}
        disableAutoFocus
        disableBackdropClick
        disableEnforceFocus
        hideBackdrop
        keepMounted
        className={classes.modal}>

        <Loader
            size="large"
            className={classes.loader}
        />

    </Modal>
)

export default Element;